import { defineStore } from 'pinia';

type State = {
  helpPanelExpanded: boolean;
  helpPanelHighlighted: boolean;
  isMobileApp: boolean;
  routeViewKey?: string;
};

export const useApplicationStore = defineStore('application', {
  state: (): State => ({
    helpPanelExpanded: false,
    helpPanelHighlighted: false,
    isMobileApp: false,
    routeViewKey: undefined,
  }),

  actions: {
    setHelpPanelExpansion(expanded: boolean) {
      this.helpPanelExpanded = expanded;
      if (!expanded) {
        this.helpPanelHighlighted = false;
      }
    },
    setHelpPanelHighlighted(highlighted: boolean) {
      this.helpPanelHighlighted = highlighted;
    },
    setIsMobileApp(isMobileApp: boolean) {
      this.isMobileApp = isMobileApp;
    },
    setRouteViewKey(key: string) {
      this.routeViewKey = key;
    },
    processUrlParams() {
      if (
        window.location.search &&
        window.location.search.includes('isApp=true')
      ) {
        this.setIsMobileApp(true);
      }
    },
  },
});
